export const translations = {
  es: {
    topbar: {
      freeShipping: 'Envío gratis en pedidos superiores a $150',
    },
    nav: {
      women: 'Mujer',
      men: 'Hombre',
      accessories: 'Accesorios',
      recovery: 'Recuperación',
      support: 'Soporte',
      kits: 'Kits',
    },
    hero: {
      headline: 'Tu recuperación empieza aquí',
      subtitle:
        'Fajas colombianas premium para resultados visibles desde el primer día',
      shopNow: 'Comprar ahora',
      whatsapp: 'Asesoría por WhatsApp',
    },
    trust: {
      postSurgery: 'Recomendado post cirugía',
      shipping: 'Envío express 1-3 días',
      payment: 'Pago seguro Zelle/Tarjeta/PayPal',
      guidance: 'Asesoría personalizada',
    },
    categories: {
      title: 'Nuestras categorías',
      viewMore: 'Ver más →',
      bestSeller: 'Más vendido',
      women: 'Fajas Mujer',
      men: 'Fajas Hombre',
      accessories: 'Accesorios Postquirúrgicos',
      recovery: 'Recuperación y Cuidado',
      support: 'Soporte y Complementos',
      kits: 'KITS / COMBOS',
    },
    kits: {
      title: 'Kits diseñados para tu tipo de cirugía',
      bbl: 'Kit BBL Completo',
      lipo: 'Kit Lipo Abdomen',
      basic: 'Kit Recuperación Básica',
      premium: 'Kit Premium Completo',
      save: 'Ahorras',
      viewFull: 'Ver kit completo',
    },
    testimonials: {
      title: 'Resultados reales de pacientes reales',
      t1: {
        quote:
          'La compresión es perfecta y súper cómoda para dormir. Vi resultados desde la primera semana.',
        name: 'María G.',
        surgery: 'LIPO 360',
      },
      t2: {
        quote:
          'Mantiene la forma de mi BBL intacta mientras da soporte donde más lo necesito. Increíble calidad.',
        name: 'Carolina S.',
        surgery: 'BBL',
      },
      t3: {
        quote:
          'La tela es súper suave con mis cicatrices. Me ha dado mucha seguridad en mi recuperación.',
        name: 'Andrea P.',
        surgery: 'TUMMY TUCK',
      },
      t4: {
        quote:
          'Soporte discreto y efectivo. Nadie nota que la llevo puesta debajo de la ropa de trabajo.',
        name: 'Luis R.',
        surgery: 'LIPOESCULTURA',
      },
    },
    bestSellers: {
      title: 'Más vendidos',
      viewProduct: 'Ver producto',
      addToRecovery: 'Agregar a mi recuperación',
      p1: 'Faja Stage 1 Lipo 360',
      p2: 'Faja BBL Stage 2',
      p3: 'Faja Hombre Compresión Total',
      p4: 'Tabla Abdominal Lumbar',
      p5: 'Espuma Anatómica Abdomen',
      p6: 'Brasier Postquirúrgico',
      p7: 'Gel Reductor Cicatrices',
      p8: 'Faja Body Completa',
    },
    footer: {
      tagline: 'Premium Shapewear & Curves',
      mission:
        'Acompañándote en cada etapa de tu recuperación con calidad y cuidado.',
      shipping: 'Envíos',
      returns: 'Devoluciones',
      sizeGuide: 'Guía de tallas',
      contact: 'Contacto',
      faq: 'FAQ',
      newsletter: 'Suscríbete y recibe 10% en tu primera compra',
      madeIn: 'Hecho con cuidado en Miami',
    },
    product: {
      reviews: 'opiniones',
      specialPrice: 'Precio especial post-cirugía',
      desc: 'Diseñada específicamente para la primera etapa de recuperación. Brinda compresión uniforme, reduce la inflamación y moldea tu figura con total comodidad.',
      sizeGuide: 'Guía de tallas →',
      buyWhatsapp: 'Comprar por WhatsApp',
      recommendedFor: 'Indicado para',
      howToUse: 'Cómo usarlo',
      fabric: 'Material',
      care: 'Cuidado',
      fabricDesc:
        'Powernet de alta compresión, algodón interior, sin costuras visibles.',
      careDesc:
        'Lavar a mano con agua fría y jabón suave. No usar secadora ni retorcer.',
      howToUseDesc:
        'Paso 1: Sube la faja poco a poco. Paso 2: Ajusta los ganchos de abajo hacia arriba. Paso 3: Acomoda los tirantes.',
      recommendedDesc: 'Lipo 360, Tummy Tuck, Postparto, Uso diario.',
      fbt: 'Frecuentemente comprado junto',
      buyAll: 'Comprar los 3',
      availableAsKit: 'Disponible como Kit BBL Completo →',
      related: 'Productos relacionados',
      home: 'Inicio',
    },
  },
  en: {
    topbar: {
      freeShipping: 'Free shipping on orders over $150',
    },
    nav: {
      women: 'Women',
      men: 'Men',
      accessories: 'Accessories',
      recovery: 'Recovery',
      support: 'Support',
      kits: 'Kits',
    },
    hero: {
      headline: 'Your recovery starts here',
      subtitle: 'Premium Colombian shapewear for visible results from day one',
      shopNow: 'Shop now',
      whatsapp: 'Chat on WhatsApp',
    },
    trust: {
      postSurgery: 'Recommended post-surgery',
      shipping: 'Express shipping 1-3 days',
      payment: 'Secure payment Zelle/Card/PayPal',
      guidance: 'Personalized guidance',
    },
    categories: {
      title: 'Our categories',
      viewMore: 'View more →',
      bestSeller: 'Best seller',
      women: "Women's Shapewear",
      men: "Men's Shapewear",
      accessories: 'Post-Surgical Accessories',
      recovery: 'Recovery & Care',
      support: 'Support & Essentials',
      kits: 'KITS & BUNDLES',
    },
    kits: {
      title: 'Kits designed for your surgery type',
      bbl: 'BBL Complete Kit',
      lipo: 'Lipo Abdomen Kit',
      basic: 'Basic Recovery Kit',
      premium: 'Premium Complete Kit',
      save: 'Save',
      viewFull: 'View full kit',
    },
    testimonials: {
      title: 'Real results from real patients',
      t1: {
        quote:
          'The compression is perfect and super comfortable to sleep in. I saw results from week one.',
        name: 'Maria G.',
        surgery: 'LIPO 360',
      },
      t2: {
        quote:
          'Keeps my BBL shape intact while giving support exactly where I need it. Incredible quality.',
        name: 'Carolina S.',
        surgery: 'BBL',
      },
      t3: {
        quote:
          'The fabric is super gentle on my scars. It has given me so much confidence in my recovery.',
        name: 'Andrea P.',
        surgery: 'TUMMY TUCK',
      },
      t4: {
        quote:
          'Discreet and effective support. No one notices I am wearing it under my work clothes.',
        name: 'Luis R.',
        surgery: 'LIPOESCULTURA',
      },
    },
    bestSellers: {
      title: 'Best sellers',
      viewProduct: 'View product',
      addToRecovery: 'Add to my recovery',
      p1: 'Stage 1 Lipo 360 Faja',
      p2: 'Stage 2 BBL Faja',
      p3: 'Men Total Compression Faja',
      p4: 'Lumbar Abdominal Board',
      p5: 'Anatomical Abdomen Foam',
      p6: 'Post-Surgical Bra',
      p7: 'Scar Reduction Gel',
      p8: 'Full Body Faja',
    },
    footer: {
      tagline: 'Premium Shapewear & Curves',
      mission:
        'Supporting you through every stage of your recovery with quality and care.',
      shipping: 'Shipping',
      returns: 'Returns',
      sizeGuide: 'Size guide',
      contact: 'Contact',
      faq: 'FAQ',
      newsletter: 'Subscribe and get 10% off your first order',
      madeIn: 'Made with care in Miami',
    },
    product: {
      reviews: 'reviews',
      specialPrice: 'Post-surgery special price',
      desc: 'Designed specifically for the first stage of recovery. Provides uniform compression, reduces swelling, and shapes your curves with total comfort.',
      sizeGuide: 'Size guide →',
      buyWhatsapp: 'Buy via WhatsApp',
      recommendedFor: 'Recommended for',
      howToUse: 'How to use',
      fabric: 'Fabric',
      care: 'Care',
      fabricDesc: 'High-compression powernet, cotton lining, seamless design.',
      careDesc:
        'Hand wash with cold water and mild soap. Do not tumble dry or wring.',
      howToUseDesc:
        'Step 1: Pull up the faja gradually. Step 2: Fasten the hooks from bottom to top. Step 3: Adjust the straps.',
      recommendedDesc: 'Lipo 360, Tummy Tuck, Postpartum, Daily use.',
      fbt: 'Frequently bought together',
      buyAll: 'Buy all 3',
      availableAsKit: 'Available as BBL Complete Kit →',
      related: 'Related products',
      home: 'Home',
    },
  },
}

export type Language = 'es' | 'en'
export type Translations = typeof translations.es
